import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { Link } from 'react-router-dom';
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ImageVideoSlider from '../components/ImageVideoSlider';
import ProjektSlider from '../components/ProjektSlider';
import NewsSlider from '../components/NewsSlider';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import Aktuelles from '../modules/Aktuelles';
import Breadcrumbs from '../components/Breadcrumbs';
import SEO from '../components/Seo';
import loadingAnimation from "../animations/data3.json";
import Lottie from "lottie-react";

export const Home = () => {

  const [isLoading, setIsLoading] = useState(false);
  const [pageData, setPageData] = useState(null);
  const [modules, setModules] = useState(null);

  const [metaData, setMetaData] = useState(null);

  const getPageData = async () => {
    setIsLoading(true)
    try {
      const response = await fetch("https://backend.bgzurlinden.ch/api/homepage?populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Beitrags_Miniaturbild]=true&populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Video][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur][populate]=*&populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.news][populate][aktuelles][populate][Bannerbereich][on][header.header-1-titel-text][populate][Button][populate]=*&populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*&populate[Metadaten]=*&populate[Banner_Schaltflaeche]=*&populate[Banner_Video]=true&populate[Banner_Videominiatur]=true");

      // &populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Beitrags_Miniaturbild]=true
      // Beitrags_Miniaturbild


      // const response = await fetch(
      //   "https://backend.bgzurlinden.ch/api/homepage?" +

      //   // short-titel-titel-text-button
      //   "populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*" +
      //   "&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*" +

      //   // projekte-portfolio → neubauprojekte_posts → Bannerbereich → header-1
      //   "&populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Bannerbereich][on][header.header-1-titel-text][populate][Button][populate]=*" +
      //   "&populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Bannerbereich][on][header.header-1-titel-text][populate][PDF][populate][PDF][populate]=*" +

      //   // projekte-portfolio → neubauprojekte_posts → Bannerbereich → header-2
      //   "&populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true" +

      //   // projekte-portfolio → neubauprojekte_posts → Bannerbereich → header-3
      //   "&populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true" +
      //   "&populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Button][populate]=*" +
      //   "&populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][PDF][populate][PDF][populate]=*" +

      //   // carousel-bild-re-text
      //   "&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true" +
      //   "&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*" +
      //   "&populate[Modul][on][modules.carousel-bild-re-text][populate][PDF][populate][PDF][populate]=*" +
      //   "&populate[Modul][on][modules.carousel-bild-re-text][populate][Video][populate]=*" +
      //   "&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur][populate]=*" +

      //   // news → Kurztitel_Titel_Text_Button
      //   "&populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*" +

      //   // news → aktuelles → carousel-bild-re-text
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true" +
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*" +
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][PDF][populate][PDF][populate]=*" +
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][Video][populate]=*" +
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][Videominiatur][populate]=*" +

      //   // news → aktuelles → Bannerbereich → header-1
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Bannerbereich][on][header.header-1-titel-text][populate][Button][populate]=*" +
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Bannerbereich][on][header.header-1-titel-text][populate][PDF][populate][PDF][populate]=*" +

      //   // news → aktuelles → Bannerbereich → header-2
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true" +

      //   // news → aktuelles → Bannerbereich → header-3
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true" +
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Button][populate]=*" +
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][PDF][populate][PDF][populate]=*" +

      //   // news → aktuelles_kategorie
      //   "&populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*" +

      //   // metadata
      //   "&populate[Metadaten]=*" +

      //   // banner schaltflaeche
      //   "&populate[Banner_Schaltflaeche]=*"
      // );


      // &populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true

      // &populate[Modul][on][modules.bilder-und-videos][populate][Video][populate]=*&populate[Modul][on][modules.bilder-und-videos][populate][Videominiatur][populate]=*

      // &populate[Modul][on][modules.carousel-bild-re-text][populate][Video][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur][populate]=*

      // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
      // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

      const data = await response.json();
      console.log(data?.data?.Modul);

      if (data.data) {
        setPageData(data.data);
        setMetaData(data.data?.Metadaten);
        setModules(data?.data?.Modul)
      }
    }
    catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }

  }

  useEffect(() => {
    getPageData();
  }, [])


  return (
    <div className='page-content'>
      {metaData && <SEO seoData={metaData} />}
      <section className='banner_sec main_banner position-relative' >
        {/* <section className='banner_sec main_banner position-relative' style={{ backgroundImage: "url('/images/home-banner.png')", backgroundSize: "cover", backgroundPosition: "center" }}> */}
        {/* <video src="/images/output.mp4" className='header-video' autoPlay loop muted></video> */}
        <video
          // src="/images/output.mp4"
          src={`https://backend.bgzurlinden.ch${pageData?.Banner_Video?.url}`}
          className="header-video"
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          preload="auto"
          poster={`https://backend.bgzurlinden.ch${pageData?.Banner_Videominiatur?.url}`}
        >
        </video>
        <div className='container'>
          <div className='banner_gif_loader'>
            {/* <img src='images/animation2.gif' className='img-fluid' alt='#' /> */}
            <Lottie animationData={loadingAnimation} loop={false} />
          </div>
          {/* <div className='banner-btn d-flex justify-content-end align-items-end' style={{ height: '57px' }}>
            {pageData?.Banner_Schaltflaeche?.button_text && <Link to={pageData?.Banner_Schaltflaeche?.button_link || '/'} className='button orange_btn'>{pageData?.Banner_Schaltflaeche?.button_text || "test"}</Link>}
            {/* {pageData?.Banner_Schaltflaeche?.button_text && <Link to={pageData?.Banner_Schaltflaeche?.button_link} className='button orange_btn'>{pageData?.Banner_Schaltflaeche?.button_text}</Link>} 
          </div> */}
        </div>
      </section>


      {/* <div className='page-breadcrumb pt-5'>
        <Breadcrumbs buttonText={"zurlinden"} />
      </div> */}


      {!isLoading ? (
        modules?.map((module, index) => (
          <React.Fragment key={index}>

            {module.__component === "modules.short-titel-titel-text-button" &&
              <section className={`pt-pb-10 sec-${module?.Kurztitel === "Projekte & Portfolio" ? 'blue' : 'orange'}-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                <div className='container'>
                  {module?.Titel === "Die innovative Genossenschaft" && <div className='subtitle'><img src='https://backend.bgzurlinden.ch/uploads/logo_icon_981b559742.svg' alt='#' /> zurlinden</div>}
                  <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                </div>
              </section>
            }
            {module.__component === "modules.projekte-portfolio" &&
              <section className={`pt-pb-10 pb-0 ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''} sec-blue-color`}>
                <div className='container'>
                  <ProjektSlider title={module?.Kurztitel_Titel_Text_Button?.Titel} text={module?.Kurztitel_Titel_Text_Button?.Text} buttons={module?.Kurztitel_Titel_Text_Button?.Button} projects={module?.neubauprojekte_posts} seperator={true} />
                </div>
              </section>}

            {module.__component === "modules.carousel-bild-re-text" &&
              <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor={ module?.Kurztitel === "Nachhaltigkeit" ? "green" : "blue"} imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} halfGrey={false} />
            }

            {module.__component === "modules.news" &&
              <section className='pt-pb-10 sec-bg-grey sec-pink-color sec-subtitle-black'>
                <div className='container'>
                  <Aktuelles shortTitle={module?.Kurztitel_Titel_Text_Button?.Kurztitel} title={module?.Kurztitel_Titel_Text_Button?.Titel} text={module?.Kurztitel_Titel_Text_Button?.Text} aktuelles={module?.aktuelles} />
                </div>
              </section>}
          </React.Fragment>
        ))
      ) : (
        <section className='wi_full inner_banner'>
          {/* <TitleComponent isLoading={isLoading} /> */}
        </section>
      )}
    </div>
  )
}